import React from "react";
import "./index.css";
import { GAME_INFO } from "../../Utils/constants";

const Footer = () => {
  const d = new Date();
  const year = d.getFullYear();
  return (
    <footer className="footer">
      <div className="footer-content">
        <span>{GAME_INFO.SHORT_NAME} 2.10.5</span>
        <span>
          © {GAME_INFO.SHORT_NAME} Copyright {year}. All rights reserved.
        </span>
        <span>Privacy Policy</span>
      </div>
    </footer>
  );
};

export default Footer;
